import { defaultScriptUrlPattern, load as fingerprintLoad } from "@fingerprintjs/fingerprintjs-pro";

export default new class FingerprintService {
    public async getFingerprint(): Promise<string | undefined> {
        try {
            const fpPromise = await fingerprintLoad({
                apiKey: "Dtm5Xs6ljR83MCFWv8Kr",
                endpoint: "https://loki.odkarla.cz",
                region: "eu",
                scriptUrlPattern: [
                    "https://loki.odkarla.cz/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
                    defaultScriptUrlPattern,
                ],
            });

            const fingerprint = await fpPromise.get();

            return JSON.stringify(fingerprint);
        } catch {
            return undefined;
        }
    }
}();
